/* eslint quote-props: 0 */  // --> OFF
/* eslint quotes: 0 */  // --> OFF
export const AppConfig = {
  "Contact": {
    email: 'contact@azyapps.com'
  },
  "Name": "TODO-NAME",
  "CompanyName": "TODO-Company",
  "Version": "2.0.15.0",
  "TERMS": "https://TODO/terms",
  "SUPPORT_EMAIL": "contact@TODO",
  "CLOUD_REGION": "TODO",
  "COGNITO_USER_POOL": "12345678908-TODO",
  "COGNITO_USER_POOL_CLIENT_ID": "12345678908-TODO",
  //"ENDPOINT": "http://ec2-13-233-44-163.ap-south-1.compute.amazonaws.com/api-v1",
  //"ENDPOINT": "http://localhost:3000",
  //"ENDPOINT": "http://ec2-13-234-122-125.ap-south-1.compute.amazonaws.com/api-v1",
  //"ENDPOINT": "/api-v1",
  "ENDPOINT": "https://api.in.uncannyvision.ai/api-v1",
  //"ENDPOINT": "http://localhost:3000/api-v1",
  "localAuth": false,
  "camLiveTab": false,
  "navbarTitle": null,
  "showAutoUpdateToggle": true,
  "eventQueryLimit": 500,
  "eventRefreshInterval": 10000,
  "imageFeedRefreshInterval": 10000,
  "parkingFeedRefreshInterval": 5000,
  "jpegPlayerRefreshInterval": 2000,
  "productName": "Uncanny Surveillance",
  "mapK": "AhBVLeZEl9lnaie15GuW_pVIAUAMcmsWT-IGiDBmVLmBIVsaG0hMn9bm6ZN_yvDj",
  "viewMode": "List",
  "adminDashboard": "/orgs",
  "eventPriorityLevels": [
    {
      "pText": "Very Low",
      "pValue": 0
    },
    {
      "pText": "Low",
      "pValue": 1
    },
    {
      "pText": "Medium",
      "pValue": 2
    },
    {
      "pText": "High",
      "pValue": 3
    }
  ],
  "userDefaultSettings": {
    ALERT_EMAIL: "OFF",
    EVENT_VISIBILITY: "0",
    EVENT_EMAIL_ALERT: "3",
    CAMERAS: [],
  },
  "userRoles": [
    {
      name: 'ADMIN',
      key: 'ADMIN',
    },
    {
      name: 'REGULAR',
      key: 'REGULAR',
    },
    {
      name: 'RESIDENT',
      key: 'RESIDENT',
    },
  ],
  placeTypes: []
}


// WEBPACK FOOTER //
// ./src/AppConfig.js